import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SplitterBase from './SplitterBase';
import SplitterText from './SplitterText';

const styles = () => ({
  root: {},
  paper: {},
  text: {},
});

const Splitter = ({
  classes,
  className,
  text,
}) => (
  <SplitterBase
    classes={{ root: classNames(classes.root, className) }}
  >
    <SplitterText
      classes={{
        root: classes.paper,
        text: classes.text,
      }}
      text={text}
    />
  </SplitterBase>
);

Splitter.defaultProps = {
  className: '',
};

Splitter.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
};

export default withStyles(styles)(Splitter);
